import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map } from 'rxjs';

@Component({
  selector: 'app-queues',
  templateUrl: './queues.component.html',
  styleUrls: ['./queues.component.scss'],
})
export class QueuesComponent implements OnInit {
  constructor(
    private utils: Utils,
    private webStorage: WebStorageService,
    private appService: AppService,
    private managerService: ManagerService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private HeaderComponent: HeaderComponent,
    private DialerService: DialerService
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  showTable: boolean = true;
  showCrud: boolean = false;

  showDateRange: boolean = false;

  modalRef?: BsModalRef;
  queueList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];

  localStorageName = 'QueuesColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    { label: 'Name', value: 'Name' },
    { label: 'Queue ID', value: 'ID' },
  ];
  selectedFilterByField: any = '';
  filterVal: any = '';

  cols: any = [
    { name: 'ID', label: 'ID', showFilter: true },
    { name: 'Name', label: 'Name', showFilter: true },
    { name: 'Type', label: 'Type', showFilter: true },
    { name: 'DialerType', label: 'Dialer Type', showFilter: true },
    { name: 'PhoneNumber', label: 'Phone Number' },
    { name: 'Status', label: 'Status', showFilter: true },
    { name: 'Testing', label: 'Testing', showFilter: true },
    {
      name: 'SLATotal',
      label: 'SLA Window',
      type: 'numeric',
      format: 'duration',
    },
    { name: 'Length', label: 'Queue Length', type: 'numeric' },
    { name: 'AssignedCount', label: 'Agent Count', type: 'numeric' },
    { name: 'LastUpdated', label: 'Last Updated', type: 'date' },
  ];

  ngOnInit(): void {
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu.name;
    });
    this.selectedFilterByField = this.findOptions[0];
    this.loadQueues();
    this.initializeColumnHeader();
    this.HeaderComponent.changeUserStatusHeader();
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.filterVal = '';
    this.filteredData = this.queueList;
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }

  clearFilter() {
    this.cols?.forEach((col: any) => {
      delete col.filterVals;
    });
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }

  applyFilterByField(val) {
    this.selectedFilterByField = val.searchField;
    this.filterVal = val.searchValue;
    if (this.selectedFilterByField.value != '' && this.filterVal != '') {
      this.filteredData = this.findByMatchingProperties(this.queueList, this.selectedFilterByField, this.filterVal);

      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    }
  }

  findByMatchingProperties(set: any, properties: any, searchText: string) {
    return set.filter((entry: any) => {
      if (typeof entry[properties.value] === 'number') {
        if (entry[properties.value].toString() == searchText) {
          return entry;
        }
      } else if (entry[properties.value].toString().toLowerCase().includes(searchText.toLowerCase())) return entry;
    });
  }

  /*column filter* starts here*/

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (!col.filterVals) {
          // Get unique values from the filtered data for this column
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]).filter(val => val != null))];
          const filterData: any = [];
          for (const val of unique) {
            // All values start unchecked when creating for the first time
            filterData.push({ name: val.toString(), checked: false });
          }
          col.filterVals = filterData;
        }
        // If filterVals already exists, we preserve the existing checked states automatically
      }
    }
    this.showColumnFilterModal(colName);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    });
  }

  /*column level filter*/
  applyColumnFilters(list: any) {
    //apply column filter here and assign to dataTodisplay
    let records = list;
    for (const colData of this.cols) {
      const filterVals: any = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name);
          }
        }
        //filterVals
        records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
      }
    }
    return records;
  }
  filterBySelectedFieldValues(set: any, properties: string, searchText: any[]) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          // Convert both values to string for proper comparison
          const entryValue = entry[properties] != null ? entry[properties].toString() : '';
          const searchValue = search != null ? search.toString() : '';
          if (entryValue === searchValue) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
    this.modalRef.content.event.subscribe(() => {
      this.initializeColumnHeader();
    });
  }

  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }

  onRowSelect(event: any) {
    this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  loadQueues() {
    this.managerService
      .GetQueues()
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetQueues');
          if (isValid) {
            this.queueList = data.Response.Data;
            this.filteredData = this.queueList;
            this.dataToDisplay = this.queueList;
            this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
}
